/* eslint-disable no-console */

import { datadogRum } from '@datadog/browser-rum';

import { getExtendedLogger } from '@mindtickle/ui-shell-core/Logger';

import { DEFAULT_META_DATA, UNAUTHORIZED_ERROR, UNAUTHORIZED_ERROR_CODE } from './config/constants';
import logger from '~/config/app.logger';

const log = getExtendedLogger('integration-tools', logger);

declare global {
  interface Window {
    DD_RUM?: typeof datadogRum;
  }
}

export function getSessionReplayUrl() {
  try {
    const ddRum = window.DD_RUM;
    if (ddRum) {
      return ddRum.getSessionReplayLink?.();
    } else {
      return '';
    }
  } catch (e) {
    log('Not able to extract Datadog Session Replay url', e);
    return '';
  }
}

const getNetworkStatus = () => ({
  networkStatus: navigator?.onLine,
  networkSpeed: navigator?.connection?.downlink,
});

// eslint-disable-next-line complexity
const isUnauthorizedError = (error: any) => {
  const responseStatus = error?.res?.status;
  const causeStatus = error?.cause?.status;
  const statusCode = error?.statusCode;
  const apolloStatusCode = error?.networkError?.statusCode;
  const revqErrorCode = error?.errorMsg?.status;
  return (
    responseStatus === UNAUTHORIZED_ERROR_CODE ||
    error === UNAUTHORIZED_ERROR ||
    causeStatus === UNAUTHORIZED_ERROR_CODE ||
    statusCode === UNAUTHORIZED_ERROR_CODE ||
    apolloStatusCode === UNAUTHORIZED_ERROR_CODE ||
    revqErrorCode === UNAUTHORIZED_ERROR_CODE
  );
};

export const handleUnauthorizedError = (error: any) => {
  if (isUnauthorizedError(error)) {
    log('Skipping logging error because of un-authorised call');
    return true;
  }
  return false;
};

export function logToDatadog(error: Error, metaData: any) {
  try {
    if (window.DD_RUM) {
      log('reporting error to DD', error);
      metaData.sessionReplayUrl = getSessionReplayUrl();
      window.DD_RUM.addError(error, metaData);
    }
  } catch (error) {
    log('error occurred %0 while reporting to Datadog Integration Tools', error);
    console.error(error);
  }
}

export function logToZipy(error: Error, metaData: any) {
  log('Deprecated: Reporting error to Zipy', error, metaData);
}

const getClassProperties = (instance: any) => {
  const dataSet: any = {};
  try {
    dataSet.errorObj = {};
    for (const property in instance) {
      dataSet.errorObj[property] = instance[property];
    }
  } catch (e) {
    log('Error object is not a type of CustomError class property', e);
  }
  return dataSet;
};

export function logErrorToIntegrationTools(error: Error, config: Record<string, any> = {}) {
  const unauthorizedError = handleUnauthorizedError(error);
  if (unauthorizedError) return;

  log(
    'error captured via logErrorToIntegrationTools utility %o with %o additional values',
    error,
    config
  );
  const errorDataSet = getClassProperties(error);
  const metaData: any = { ...DEFAULT_META_DATA, ...getNetworkStatus(), ...config, ...errorDataSet };

  // Log error to Datadog
  logToDatadog(error, metaData);
}
